__turbopack_context__.v({
  "active": "advanced-sidebar-module-sass-module__VWVC1G__active" + " " + __turbopack_context__.i(488939)["active"],
  "advancedSidebar": "advanced-sidebar-module-sass-module__VWVC1G__advancedSidebar",
  "animate": "advanced-sidebar-module-sass-module__VWVC1G__animate",
  "content": "advanced-sidebar-module-sass-module__VWVC1G__content",
  "navItem": "advanced-sidebar-module-sass-module__VWVC1G__navItem" + " " + __turbopack_context__.i(488939)["navItem"],
  "sportsNav": "advanced-sidebar-module-sass-module__VWVC1G__sportsNav",
});
